import { Button, Heading, Link, List, Loader } from 'arag-ui-lib'
import { amountColumnsDisplayDataPerStage, isAragUser } from '../../helpers/functions'
import StagedStep4 from './WizardSteps/stagedStep4'
import ApplicationStagedPremiumSettingsRevisionsModal from './applicationStagedPremiumSettingsRevisionsModal'
import { HEADING_2, HEADING_3, LEFT, MOMENT_DATE_TIME_FORMAT, PRIMARY, QUATERNARY, RIGHT, TERTIARY } from '../../helpers/constants'
import CONTENT_STRINGS from '../../helpers/contentStrings'
import moment from 'moment'
import { useSelector } from 'react-redux'
import Tooltip from '../General/tooltip'
import { isPigApplied } from '../../helpers/pigLock'

const ApplicationStagedPremiumSettings = (props) => {
    const {
        applicationPolicy,
        stagedPremiumSettingsWizard,
        appStagedSubSettings,
        stagedPremiums,
        onEditStaged,
        isChangingStatusOfApp,
        onCancel,
        goingLiveLoading,
        handleSubmit,
        loggedInUser,
        applicationPremiumSettingsRevisions,
        openModal,
        setOpenModal,
        selectedPreviousUpdate,
        setSelectedPreviousUpdate,
        appStagedEmphasizedFields,
        appStagedHighlightedFields,
    } = props;

    const canEditApplicationPremiumSettings = loggedInUser?.allowedToEditApplicationPremiumSettings ?? false;
    const isAragUserLoggedIn = isAragUser(loggedInUser?.roles);
    // WI 95280: Application Premium Settings become read-only once a PIG request has been sent. This is the
    // store slice the premium settings area reads the policy from (see applicationPremiumSettingsHOC).
    const pigLocked = isPigApplied(useSelector((state) => state.applicationsAndPolicies.selectedApplication));

    return (
        <div>
            <Heading 
                variant={HEADING_2}
                title={CONTENT_STRINGS.APPLICATION_PREMIUM_SETTINGS} 
                headingTestId={'application-premium-setting-modal-heading'}
            />
            {
                !(
                    applicationPolicy.premiumSettingsIndicator &&
                    goingLiveLoading
                )
                ?
                    <div>
                        <StagedStep4
                            amountColumnsDisplayDataPerStage={amountColumnsDisplayDataPerStage}
                            isApplicationPremium={true}
                            stagesSubSettings={appStagedSubSettings}
                            stagedPremiumData={stagedPremiums.stagedPremiumSetting}
                            currentStep={4}
                            emphasizedFields={appStagedEmphasizedFields}
                        />
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start' }} >
                            {
                                isChangingStatusOfApp
                                ?
                                    <div style={{ maxHeight: 34, paddingRight: 10 }}>
                                        <Button
                                            variant={PRIMARY}
                                            label={CONTENT_STRINGS.SAVE_AND_GO_LIVE}
                                            arrowDirection={RIGHT}
                                            disabled={
                                                applicationPolicy.premiumSettingsIndicator ||
                                                goingLiveLoading
                                            }
                                            onClick={handleSubmit}
                                            buttonTestId={'application-premium-setting-modal-save-and-go-live'}
                                        />
                                    </div>
                                :
                                    null
                            }
                            {
                                (canEditApplicationPremiumSettings && !pigLocked) && (
                                    <Button
                                        variant={QUATERNARY}
                                        label={CONTENT_STRINGS.EDIT}
                                        arrowDirection={RIGHT}
                                        disabled={
                                            applicationPolicy.premiumSettingsIndicator ||
                                            goingLiveLoading
                                        }
                                        onClick={onEditStaged}
                                        buttonTestId={'application-premium-setting-modal-edit'}
                                    />
                                )
                            }
                            {
                                // WI 95280: tooltip in place of the hidden Edit button.
                                (canEditApplicationPremiumSettings && pigLocked)
                                ?
                                    <Tooltip text={CONTENT_STRINGS.PIG_APPLIED_EDIT_LOCKED_TOOLTIP} />
                                :
                                    null
                            }
                            {
                                (applicationPolicy.premiumSettingsIndicator || goingLiveLoading)
                                ?
                                    <Loader />
                                :
                                    null
                            }
                            {
                                isChangingStatusOfApp
                                ?
                                    <div style={{ maxHeight: 34, paddingTop: 10 }}>
                                        <Link
                                            variant={TERTIARY}
                                            label={CONTENT_STRINGS.CANCEL}
                                            arrowDirection={LEFT}
                                            disabled={
                                                applicationPolicy.premiumSettingsIndicator ||
                                                stagedPremiumSettingsWizard.patching ||
                                                goingLiveLoading
                                            }
                                            onClick={onCancel}
                                            buttonTestId={'application-premium-setting-modal-cancel'}
                                        />
                                    </div>
                                :
                                    null
                            }
                        </div>
                        {
                            isAragUserLoggedIn && applicationPremiumSettingsRevisions?.length > 0
                            ?
                                <div className='col-sm-12'>
                                    <Heading
                                        variant={HEADING_3}
                                        title={CONTENT_STRINGS.PREVIOUS_UPDATES}
                                        headingTestId={'staged-premium-previous-updates-header'}
                                    />
                                    <List
                                        id="stagedPremiumSettings-PreviousUpdates-list"
                                        items={applicationPremiumSettingsRevisions.map((update, index) => ({
                                            content: (
                                                <Link
                                                    variant={TERTIARY}
                                                    key={index}
                                                    onClick={() => {
                                                        setSelectedPreviousUpdate(update);
                                                        setOpenModal(true);
                                                    }}
                                                    label={moment(update.revisionDate ?? update.createdDate).format(MOMENT_DATE_TIME_FORMAT)}
                                                    linkTestId={`staged-premium-previous-update-${index}`}
                                                />
                                            ),
                                        }))}
                                    />
                                    {
                                        selectedPreviousUpdate
                                        ?
                                            <ApplicationStagedPremiumSettingsRevisionsModal
                                                isOpen={openModal}
                                                onClose={() => setOpenModal(false)}
                                                revision={selectedPreviousUpdate}
                                                revisionIndex={applicationPremiumSettingsRevisions.indexOf(selectedPreviousUpdate)}
                                                highlightedFields={appStagedHighlightedFields}
                                            />
                                        :
                                            null
                                    }
                                </div>
                            :
                                null
                        }
                    </div>
                :
                    <Loader />
            }
        </div>
    )
}
export default ApplicationStagedPremiumSettings
